"use client";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";
const useAuthInfo = create(
  persist(
    (set, get) => ({
      apiToken: "",
      userId: "",
      companies: [],
      permissions: [],
      imageUrl: "",
      fullName: "",
      isVerified:null,
      updateAuthStore: (data) => {
        set(() => ({
          apiToken: data.apiToken,
          userId: data.userId,
          companies: data.companies,
          permissions: data.permissions,
          imageUrl: data.imageUrl,
          fullName: data.fullName,
          isVerified: data.isVerified,
        }));
        setTimeout(() => {
          toast.success("Logged In Successfully", {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }, 500);
      },
      verificationUpdate:(value)=>{
        set((state)=>({
          ...state,
          isVerified:value
        }))
      },
      logout: () => {
        set(() => ({
          apiToken: "",
          userId: "",
          companies: [],
          permissions: [],
          imageUrl: "",
          fullName: "",
          isVerified: null,
        }));
        window.location.href = "/";
        setTimeout(() => {
          toast.success("Logged Out Successfully", {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }, 500);
      },
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => secureLocalStorage),
      skipHydration: true,
    }
  )
);
export default useAuthInfo;
